import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'

export function ContentRouteBreadCrumb() {
  const { Link } = useRouter()
  return (
    <Link href={adminRoutes.content.root}>
      <T id="Generics.Content" defaultMessage="Content" />
    </Link>
  )
}
